import React, { memo } from 'react'
import { useField } from 'formik'
import { BasicTextField } from 'src/components/shared/form/BasicTextField'

interface Props {
  /** A FieldArray path, e.g. `rows[2].fee`. */
  name: string
  label?: string
  placeholder?: string
  disabled: boolean
}

/**
 * `FormikTextField` indexes `values[name]` with `name: keyof T`, so it cannot address a
 * FieldArray path — `values['rows[2].fee']` is undefined and `errors[name]` does not resolve
 * dotted paths. `useField` does. Lives here rather than in `components/shared/form` because
 * changing a shared component for one feature risks every existing caller.
 */
const VendorFeeTextFieldComponent = ({ name, label, placeholder, disabled }: Props) => {
  const [field, meta] = useField<string>(name)

  return (
    <BasicTextField<Record<string, string>>
      name={name}
      label={label}
      value={field.value}
      placeholder={placeholder}
      error={Boolean(meta.touched && meta.error)}
      helperText={meta.touched && meta.error}
      disabled={disabled}
      onChange={field.onChange}
      onBlur={field.onBlur}
    />
  )
}

export const VendorFeeTextField = memo(VendorFeeTextFieldComponent)
